import { useCallback, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useBlocker } from 'react-router'
import { useConfirm } from '~/components'

const usePrompt = (props) => {
  const { t } = useTranslation()

  const {
    isDirty = false,
    title = t('prompt.unsaved.title'),
    body = t('prompt.unsaved.body'),
    actions: actionsProp,
    onClose,
  } = props

  const actions = useMemo(() => {
    if (actionsProp) return actionsProp
    return [
      { id: 'confirm', name: t('ui.confirm'), variant: 'contained' },
      { id: 'cancel', name: t('ui.cancel'), variant: 'outlined' },
    ]
  }, [actionsProp, t])

  const blocker = useBlocker(isDirty)

  const { show } = useConfirm()

  const confirm = useCallback(() => {
    if (!isDirty) return Promise.resolve(true)
    return new Promise((resolve) => {
      show({
        title,
        body,
        actions,
        onClose: (action) => {
          onClose?.(action)
          resolve(action === 'confirm')
        },
      })
    })
  }, [actions, body, isDirty, onClose, show, title])

  useEffect(() => {
    if (blocker.state === 'blocked') {
      confirm().then((result) => {
        if (result) blocker.proceed()
        else blocker.reset()
      })
    }
  }, [blocker, confirm])

  useEffect(() => {
    if (isDirty) {
      window.onbeforeunload = () => title
    }
    return () => {
      window.onbeforeunload = null
    }
  }, [isDirty, title])
}

export default usePrompt
